/* unplugin-vue-components disabled */import { render } from "./education.vue?vue&type=template&id=4aad7b45&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"

import "./education.vue?vue&type=style&index=0&id=4aad7b45&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4aad7b45"],['__file',"src/components/cards-v2/persona/education/education.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4aad7b45"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4aad7b45', __exports__)) {
    api.reload('4aad7b45', __exports__)
  }
  
  module.hot.accept("./education.vue?vue&type=template&id=4aad7b45&scoped=true", () => {
    api.rerender('4aad7b45', render)
  })

}


export default __exports__